import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import { checkIfHotjarEnable, timeBetweenDates } from '../utils/helpers';
import history from '../utils/history';
import * as sinisterCardsActions from '../redux/actions/sinister-cards';
import RimacTopBar from '../components/common/RimacTopBar/RimacTopBar';
import Navbar from '../components/common/Navbar/Navbar';
import InfoCard from '../components/content/InfoCard/InfoCard';
import Input from '../components/common/input/Input';
import InfoIcon from '../assets/infoIcon.svg';

const AmountInfoPage = () => {
  const dispatch = useDispatch();
  const sinisterList = useSelector((state) => state.sinisterCards.sinisterList);
  const sinistersAmounts = [];
  sinisterList.forEach((sinister) => {
    let checked = '';
    if (sinister.soles && !sinister.dollars) {
      checked = 'soles';
    } else if (!sinister.soles && sinister.dollars) {
      checked = 'dollars';
    } else if (sinister.soles && sinister.dollars) {
      checked = 'ambos';
    }

    sinistersAmounts.push({
      code: sinister.code,
      sinisterNum: sinister.sinisterNum,
      title: sinister.title,
      soles: sinister.soles,
      dollars: sinister.dollars,
      warningTxt: sinister.warningTxt,
      amountInfo: sinister.amountInfo,
      solesError: '',
      dollarsError: '',
      checked,
    });
  });
  const [amounts, setAmounts] = useState(sinistersAmounts);
  const [viewStartTime, setViewStartTime] = useState(new Date());
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      let elem = document.getElementById(location.hash.slice(1));
      if (elem) {
        elem.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
  }, [location]);

  useEffect(() => {
    return () => {
      const endTime = new Date();
      const userTotalTime = timeBetweenDates(viewStartTime, endTime);

      if (checkIfHotjarEnable()) {
        window.digitalData.push({
          task: {
            name: 'Tiempo registrado - Montos robados',
            time: userTotalTime,
          },
          event: 'trackTimeToComplete',
        });
      }
    };
  }, []);

  const onRadioClick = (index, checked) => {
    const newAmounts = [...amounts];
    newAmounts[index].checked = checked;

    if (checked === 'soles') {
      newAmounts[index].dollars = '';
    } else if (checked === 'dollars') {
      newAmounts[index].soles = '';
    }

    setAmounts(newAmounts);
  };

  const inputSolesHandler = (index, val) => {
    const newAmounts = [...amounts];
    const solesAmountMax = 1000000;
    newAmounts[index].soles = val;

    if (Number(val) === 0 && val !== '') {
      newAmounts[index].solesError = 'Por favor ingresa un monto válido';
      setAmounts(newAmounts);
      return;
    }

    // if(!val && !dollars) {
    //   newAmounts[index].soles = '';
    //   newAmounts[index].error = 'Por favor ingresa un monto válido';
    //   setAmounts(newAmounts);
    //   return;
    // }

    if (val >= solesAmountMax) {
      newAmounts[index].solesError = 'Por favor ingresa un monto válido';
      setAmounts(newAmounts);
      return;
    }

    newAmounts[index].solesError = '';
    setAmounts(newAmounts);

    // if(!dollarsError && (Number(dollars) !== 0 || dollars === '')) {
    //   setDollarsError('');
    // }
  };

  const inputDollarsHandler = (index, val) => {
    const newAmounts = [...amounts];
    const dollarsAmountMax = 90000;
    newAmounts[index].dollars = val;

    if (Number(val) === 0 && val !== '') {
      newAmounts[index].dollarsError = 'Por favor ingresa un monto válido';
      setAmounts(newAmounts);
      return;
    }

    // if (!val && !soles) {
    //   setDollars('');
    //   setDollarsError('*Por favor ingresa un monto válido');
    //   return;
    // }

    if (val > dollarsAmountMax) {
      newAmounts[index].dollarsError = 'Por favor ingresa un monto válido';
      setAmounts(newAmounts);
      return;
    }

    newAmounts[index].dollarsError = '';
    setAmounts(newAmounts);

    // if (!solesError && (Number(soles) !== 0 || soles === '')) {
    //   setSolesError('');
    // }
  };

  const isNextActive = () => {
    const isAnyError = amounts.some(
      (amount) => amount.solesError || amount.dollarsError
    );
    const noChecks = amounts.some((amount) => !amount.checked);
    const amountError = amounts.map((sinister) => {
      return !!(
        (sinister.checked === 'soles' && !sinister.soles) ||
        (sinister.checked === 'dollars' && !sinister.dollars) ||
        (sinister.checked === 'ambos' && (!sinister.soles || !sinister.dollars))
      );
    });

    return isAnyError || noChecks || amountError.includes(true) ? true : false;
  };

  const onBackHandler = () => {
    dispatch(sinisterCardsActions.reduceStep());
    history.replace('/documentos-requeridos');
  };

  const onContinueHandler = () => {
    const updatedSinisterList = [...sinisterList];
    updatedSinisterList.forEach((sinister) => {
      const findSinisterAmount = amounts.find(
        (amount) => amount.code === sinister.code && amount.sinisterNum === sinister.sinisterNum
      );
      sinister.soles = findSinisterAmount.soles;
      sinister.dollars = findSinisterAmount.dollars;
    });

    if (checkIfHotjarEnable()) {
      const totalAmountSoles = updatedSinisterList.reduce(
        (prev, curr) => (curr.soles ? prev + Number(curr.soles) : prev),
        0
      );
      const totalAmountDollars = updatedSinisterList.reduce(
        (prev, curr) => (curr.dollars ? prev + Number(curr.dollars) : prev),
        0
      );

      window.digitalData.push({
        metadata: {
          key: 'Monto – Protección Tarjeta BBVA',
          value: `soles - ${totalAmountSoles}`,
        },
        event: 'trackMetadata',
      });

      window.digitalData.push({
        metadata: {
          key: 'Monto – Protección Tarjeta BBVA',
          value: `soles - ${totalAmountDollars}`,
        },
        event: 'trackMetadata',
      });
    }

    dispatch(sinisterCardsActions.updateSinisterList(updatedSinisterList));
    dispatch(sinisterCardsActions.incrementStep());

    history.replace('/info-reembolso');
  };

  const sortedAmounts = amounts.sort(
    (a, b) => Number(a.sinisterNum) - Number(b.sinisterNum)
  );

  return (
    <>
      <RimacTopBar />
      <div
        data-testid="amount-info-page"
        className="amountInfoPage pageContainer"
      >
        <div className="amountInfoPage__left pageContainer__left">
          <div className="titleCont">
            <h1 className="u-mb-24">Seguro de Protección de Tarjetas</h1>
            <p>
              Hola, sabemos que sufriste un siniestro y queremos ayudarte a
              reportarlo.
            </p>
          </div>
        </div>

        <div className="amountInfoPage__right pageContainer__right">
          {sortedAmounts.map((sinister, i) => (
            <div
              id={sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code }
              key={`cont-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code }`}
              className={'u-mb-40'}
            >
              <div className="titleCont">
                <h3 className="u-mb-24">{sinister.title}</h3>
                {sinister.warningTxt && (
                  <InfoCard
                    icon={InfoIcon}
                    customClasses="u-mb-40"
                    content={
                      <p>
                        <b>Recuerda:</b> {sinister.warningTxt}
                      </p>
                    }
                  />
                )}
              </div>

              <h4 className="u-mb-16">¿En qué moneda fue el siniestro?</h4>
              <p className="u-mb-24">Selecciona una de las opciones</p>

              <fieldset className="checkCont u-mb-40">
                <label
                  className="radioBtnGen"
                  htmlFor={`check-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}-1`}
                >
                  <input
                    id={`check-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}-1`}
                    type="radio"
                    name={`radio-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}`}
                    checked={sinister.checked === 'soles'}
                    onChange={() => onRadioClick(i, 'soles')}
                  />
                  <span className="radioBtnGen__checkmark u-mr-12"></span>
                  Soles (S/)
                </label>

                <label
                  className="radioBtnGen"
                  htmlFor={`check-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}-2`}
                >
                  <input
                    id={`check-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}-2`}
                    type="radio"
                    name={`radio-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}`}
                    checked={sinister.checked === 'dollars'}
                    onChange={() => onRadioClick(i, 'dollars')}
                  />
                  <span className="radioBtnGen__checkmark u-mr-12"></span>
                  Dólares ($)
                </label>

                <label
                  className="radioBtnGen"
                  htmlFor={`check-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}-3`}
                >
                  <input
                    id={`check-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}-3`}
                    type="radio"
                    name={`radio-${sinister.code === 'COB01' ? sinister.sinisterNum: sinister.code}`}
                    checked={sinister.checked === 'ambos'}
                    onChange={() => onRadioClick(i, 'ambos')}
                  />
                  <span className="radioBtnGen__checkmark u-mr-12"></span>
                  Ambos
                </label>
              </fieldset>

              {sinister.checked && (
                <div className="amountWrapper">
                  <h4 className="u-mb-16">
                    {sinister.checked === 'ambos'
                      ? '¿Cuáles fueron los montos?'
                      : '¿Cuál fue el monto?'}
                  </h4>
                  {sinister.checked === 'soles' ||
                  sinister.checked === 'ambos' ? (
                    <div className="amountWrapper__inputCont">
                      <Input
                        type="time"
                        isCurrency
                        className={
                          sinister.checked === 'ambos' ? 'u-mb-16' : 'u-mb-8'
                        }
                        label="Monto en Soles (S/)"
                        maxLength={9}
                        currencyValue={sinister.soles}
                        onChange={(val) => inputSolesHandler(i, val)}
                        hasError={sinister.solesError}
                      />
                    </div>
                  ) : null}
                  {sinister.checked === 'dollars' ||
                  sinister.checked === 'ambos' ? (
                    <div className="amountWrapper__inputCont">
                      <Input
                        isCurrency
                        currencyPrefix={'$ '}
                        type="time"
                        className="u-mb-8"
                        label="Monto en Dólares ($)"
                        maxLength={8}
                        currencyValue={sinister.dollars}
                        onChange={(val) => inputDollarsHandler(i, val)}
                        hasError={sinister.dollarsError}
                      />
                    </div>
                  ) : null}
                </div>
              )}
              {sinister.checked && (
                <p className="coverage">{sinister.amountInfo}</p>
              )}
            </div>
          ))}
        </div>

        <Navbar
          navActive
          isNextDisabled={isNextActive()}
          onContinueClick={onContinueHandler}
          onBackClick={onBackHandler}
          currentStep={3}
          totalSteps={5}
        />

        <div className="spacingLeft"></div>
      </div>
    </>
  );
};

export default AmountInfoPage;
